import { parseISO, startOfDay } from 'date-fns';

export function getCalendarDayFromFullCalendarMarker(marker: Date): Date {
  return startOfDay(parseISO(marker.toISOString().slice(0, 10)));
}
